import type { Drug } from "../types";

export const phenoxymethylpenicillinDrug: Drug = {
  id: "phenoxymethylpenicillin",
  name: "Phenoxymethylpenicillin",
  drugClass: "penicillin",
  defaultFoodTiming:
    "Take on an empty stomach — 30 minutes before food or 2 hours after food",
  foodTiming:
    "Take on an empty stomach — 30 minutes before food or 2 hours after food",
  swallowingNote: "Tablets should be swallowed whole with water",
  paediatricLinkRefs: [
    "medicines-for-children-penv",
    "medicines-for-children-giving-tablets",
  ],
  formulations: [
    {
      id: "penv-250-tab",
      type: "tablet_ir",
      strength: 250,
      strengthUnit: "mg",
      prescribedItemId: "92644039-11eb-477e-a152-9eeab065eff5",
    },
    {
      id: "penv-125-5ml",
      type: "oral_solution",
      strength: 125,
      strengthUnit: "mg",
      volumePer: 5,
      volumeUnit: "mL",
      bottleSize: 100,
      bottleSizeUnit: "mL",
      sugarFreeAvailable: true,
      prescribedItemId: "5ea14352-09d3-43bd-8c63-0c0cae38755c",
    },
    {
      id: "penv-250-5ml",
      type: "oral_solution",
      strength: 250,
      strengthUnit: "mg",
      volumePer: 5,
      volumeUnit: "mL",
      bottleSize: 100,
      bottleSizeUnit: "mL",
      sugarFreeAvailable: true,
      prescribedItemId: "58c0cee0-071d-4414-8913-f31ae018a9f4",
    },
  ],
};
